/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Created by WJX on 2017/11/24.
 */


import { comment, personal } from '@/api/ajax.js';
import { mapState } from 'vuex';
import { loadMore } from '@/Mixin/loadMore.js'; // import { XInput } from 'vux';

import XInput from 'vux/src/components/x-input';
import Emoji from '@/components/emoji.vue';
import _signIn from './signIn.js';
import flower from './components/flower.vue';
export default {
  name: '',
  mixins: [loadMore],
  inject: ['livingStore'],
  props: {
    /*
     * @name 课程名字
     * @type 课程类型 5 直播 6 录播
     * */
    status: {
      type: String
    },
    type: {
      default: 5
    },
    name: {
      default: '没有课程名字'
    },
    qaId: {
      default: '0'
    },
    isCollection: {
      default: 0
    },
    needSocket: {
      default: false
    },
    hasSocket: {
      default: false
    },
    editor: {
      default: ''
    },
    residenceTime: Number // 停留时间

  },
  data: function data() {
    return {
      newGift: {},
      commentNameList: ['按时间', '按推荐'],
      chooseFlag: false,
      commentNameIndex: 0,
      commentContentList: [],
      commentTimeList: [],
      commentRecList: [],
      giftList: [],
      commentObj: {
        commentCount: 0,
        list: []
      },
      isReplay: {
        // 发布类型 0 发布 1 回复 item 为被回复的信息
        type: 0,
        item: {}
      },
      showReply: false,
      //是否显示回复层
      replyValue: '',
      answerId: '',
      showMore: {
        index: -1
      },
      params: {
        pageNo: 1,
        pageSize: 20,
        questionId: '',
        type: this.type || 0
      },
      loadFlag: true,
      iosKeyInter: null,
      // 2018-06-13 emoji改版
      isOpenEmoji: false,
      // 2018-06-13 emoji改版
      pageNo: 1,
      examIndex: 0,
      scrollFlag: true,
      btmFlag: false,
      ifQua: false,
      //是否认证
      quaFlag: false,
      //是否展示认证弹层
      sendFlag: false,
      shareFlag: false,
      fixFlag: 0,
      interval: ''
    };
  },
  methods: {
    closeGifts: function closeGifts() {
      this.$store.commit('CLOSEGIFTBOX', false);
    },
    scrollToTop: function scrollToTop() {
      scrollTo(0, 0);
    },
    focusEvent: function focusEvent() {
      this.isOpenEmoji = false;
      this.fixFlag = document.body.scrollTop;
      this.interval = setTimeout(function () {
        //设置一个计时器，时间设置与软键盘弹出所需时间相近
        document.body.scrollTop = document.body.scrollHeight; //获取焦点后将浏览器内所有内容高度赋给浏览器滚动部分高度
        // this.$refs.replyInput.scrollIntoView(true)
      }, 100);
    },
    initInput: function initInput() {
      this.isReplay.type = 0;
      this.$refs.replyInput.setAttribute('placeholder', '向讲师提问');
    },
    blurEvent: function blurEvent() {
      if (this.interval) {
        clearTimeout(this.interval); //清除计时器
      }

      document.body.scrollTop = this.fixFlag; // 将软键盘唤起前的浏览器滚动部分高度重新赋给改变后的高度
    },
    goQua: function goQua() {
      //展示认证弹层
      if (!this.ifQua) {
        this.quaFlag = true;
      }
    },
    toQua: function toQua() {
      //转跳立即认证
      if (!this.ifQua) {
        location.href = '/html/perfect.html#/verifi?pageFrom=upload';
      }
    },
    signIn: function signIn() {
      //签到功能
      _signIn.call(this);
    },
    hiddenEmojiComponent: function hiddenEmojiComponent() {
      this.isOpenEmoji = false;
    },
    isUseEmoji: function isUseEmoji() {
      this.isOpenEmoji = !this.isOpenEmoji;
      this.$nextTick(function () {
        scrollTo(0, document.documentElement.scrollHeight);
      });
    },
    // 获取emoji表情组件传上来的emoji表情
    getEmoji: function getEmoji(data) {
      this.replyValue += this.$emoji.get(data);
    },
    // 删除对应的表情及文字
    deleteEmoji: function deleteEmoji(data) {
      if ((this.replyValue.charAt(this.replyValue.length - 2) + this.replyValue.charAt(this.replyValue.length - 1)).match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) != null) this.replyValue = this.replyValue.substr(data, this.replyValue.length - 2);else {
        this.replyValue = this.replyValue.substr(data, this.replyValue.length - 1);
      }
    },
    // 2018-06-13 emoji改版
    pullCommentByRec: function pullCommentByRec() {
      var _this = this; //拉取更多


      this.loadFlag = false;
      comment.getRecComments({
        qaId: this.qaId,
        pageNo: this.params.pageNo
      }).then(function (res) {
        if (res.data.status == 'success') {
          var _iterator = _createForOfIteratorHelper(res.data.data.list),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              item.commentRendType = 1;

              _this.commentRecList.push(item);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (res.data.data.list.length == _this.params.pageSize) {
            //有更多
            _this.loadFlag = true;
            _this.params.pageNo += 1;
          } else {
            //无更多
            _this.loadFlag = false;
          }

          _this.commentContentList = _this.commentRecList;
        }
      });
    },
    changeType: function changeType(index) {
      //改变评论排序
      this.chooseFlag = false;

      if (this.commentNameIndex != index && index == 1) {
        //按推荐排序
        this.params.pageNo = 1;
        this.commentRecList = [];
        this.commentNameIndex = index;
        this.loadFlag = true;
        this.btmFlag = false;
        this.pullCommentByRec();
        this.$refs.pinglunqu.scrollTop = 0;
      } else if (this.commentNameIndex != index && index == 0) {
        //按时间排序
        this.commentNameIndex = index;
        this.commentContentList = this.commentTimeList;
        this.$refs.pinglunqu.scrollTop = 0;
      }
    },
    loadMoreCallBack: function loadMoreCallBack() {
      //下滑加载更多的回调
      this.getList(this.params);
    },
    stopMove: function stopMove() {
      //上滑停止滚动
      // console.log(this.$refs.pinglunqu)
      var h = this.$refs.pinglunqu.scrollHeight,
          t = this.$refs.pinglunqu.scrollTop,
          wh = this.$refs.pinglunqu.clientHeight; // console.log(t<h-wh)

      if (t < h - wh) {
        //显示回到底部
        this.scrollFlag = false;
        this.btmFlag = true;
      } else {
        this.scrollFlag = true;
        this.btmFlag = false;
      }
    },
    goBtm: function goBtm() {
      //回到底部
      this.scrollFlag = true;
      this.btmFlag = false;
      var that = this;
      setTimeout(function () {
        that.$refs.pinglunqu.scrollTop = 100 * that.commentTimeList.length;
      }, 100);
    },
    showBtm: function showBtm() {
      //回到底部
      this.scrollFlag = true;
      this.btmFlag = false;
      setTimeout(function () {
        that.$refs.pinglunqu.scrollTop = 100 * that.commentTimeList.length;
      }, 100);
    },
    initCover: function initCover() {
      //初始化弹层
      this.showReply = false;
      this.showMore.index = -1;

      if (this.iosKeyInter) {
        clearInterval(this.iosKeyInter);
        this.iosKeyInter = null;
      }
    },

    /*
     * 显示更多操作
     * */
    showMoreFunc: function showMoreFunc(item, index) {
      if (this.showMore.index == index) {
        this.showMore.index = -1;
      } else {
        this.showMore.index = index;
      }
    },
    getFocus: function getFocus() {
      var _this2 = this;

      if (!this.$api.ios()) {
        setTimeout(function () {
          _this2.$refs.comFirstText.focus();
        }, 500);
      }
    },

    /*
     * 点击input 显示回复层
     * */
    clickReplay: function clickReplay(item) {
      if (this.wxUserInfo.id != item.userId) {
        this.$refs.replyInput.setAttribute('placeholder', '回复' + item.replyUserName);
        this.isReplay.type = 1;
        this.isReplay.item = item;
      }

      this.initCover();
      this.showReply = true;
      this.$refs.replyInput.focus(); // this.getFocus()
    },
    clickRelease: function clickRelease() {
      //点击发布
      this.isOpenEmoji = false;
      this.initCover();
      this.isReplay.type = 0;
      this.showReply = true;
      this.getFocus(); // 埋点

      this.$sa.re_interaction({
        type: '评论',
        // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: this.type,
        // 互动主体 直播，录播，资讯，病例，站内信，论坛
        contentid: this.$route.params.id,
        // 内容id
        first_cate: this.categoriesList[0].categoryName,
        //一级分类
        second_cate: this.categoriesList[1].categoryName,
        // 2级分类
        first_cate_id: this.categoriesList[0].id,
        // 1级分类id
        second_cate_id: this.categoriesList[1].id,
        //2级分类id
        author: this.editor,
        //讲师/作者
        contentname: this.name // location:'', //位置 站内，专区内，超级面对面内

      });
    },

    /*
     * 删除自己的评论
     * */
    selfDelete: function selfDelete(item, index) {
      var _this3 = this;

      var data = {
        id: item.id,
        questionId: item.questionId
      };
      comment.delete(data).then(function (res) {
        if (res.data.message == 'success') {
          _this3.$vux.toast.show({
            text: '删除成功',
            type: 'text',
            width: '5rem',
            position: 'bottom'
          });

          _this3.commentObj.list.splice(index, 1);

          _this3.commentObj.commentCount = _this3.commentObj.commentCount - 1;
        } else {
          _this3.$vux.toast.show({
            text: '删除失败请重试',
            type: 'cancel',
            width: '5rem'
          });
        }
      });
      this.initCover();
    },

    /*
     * 回复 @type  0 发布 1 回复
     * */
    sendReply: function sendReply() {
      var _this4 = this; // this.showReply = true
      // this.sendFlag = false


      if (this.replyValue.length < 300 && !/^[1]{0,3}$/.test(this.replyValue) && this.replyValue) {
        this.isOpenEmoji = false;
        var dataObj = {
          content: this.replyValue,
          questionId: this.params.questionId || this.$route.params.id,
          type: this.type,
          commentTheme: this.name
        };

        if (this.isReplay.type) {
          Object.assign(dataObj, {
            answerId: this.isReplay.item.id
          });
        }

        comment.addComment(dataObj).then(function (res) {
          if (res.data.message == '操作成功') {
            _this4.initInput();

            if (window.dmsocket) {
              var data = {
                userId: _this4.wxUserInfo.id,
                userName: _this4.wxUserInfo.fullName || _this4.wxUserInfo.nickName,
                headPhoto: _this4.wxUserInfo.headPhoto,
                text: _this4.replyValue,
                createTime: new Date().getTime(),
                createDate: new Date().getTime(),
                id: res.data.data,
                isTalk: 0,
                isTop: 0,
                message: _this4.replyValue,
                nickName: _this4.wxUserInfo.fullName || _this4.wxUserInfo.nickName,
                status: 0,
                type: 4
              }; // window.dmsocket.send(JSON.stringify(data));
            } //this.getComments() //重新获取


            _this4.replyValue = '';
            _this4.params.pageNo = 1;
            _this4.commentContentList = [];
            _this4.loadFlag = true;

            _this4.getList(_this4.params);

            _this4.$refs.pinglunqu.scrollTop = 0; // this.initCover()
            // this.$refs.comWrapper.scrollTop = 0//向上锚点定位
            // try {
            //
            //   document.documentElement.scrollTop = document.querySelector('.comNum').offsetTop
            // } catch (e) {
            //
            // }

            _this4.$vux.toast.show({
              text: '发布成功',
              type: 'text',
              width: '5rem',
              position: 'bottom'
            });
          } else if (res.data.message == 'preApproval') {
            _this4.$vux.toast.show({
              text: '发布成功，审核中',
              type: 'text',
              width: '5rem',
              position: 'bottom'
            });

            _this4.replyValue = '';

            _this4.initCover();
          } else {
            _this4.$vux.toast.show({
              text: res.data.message,
              type: 'cancel',
              width: '5rem'
            });
          }
        });
      } else {
        this.$vux.toast.show({
          text: '注意格式',
          type: 'cancel',
          width: '5rem'
        });
      }
    },

    /*
     * 举报
     * */
    accusation: function accusation(item) {
      var _this5 = this;

      var data = {
        id: item.id
      };
      comment.accusation(data).then(function (res) {
        _this5.initCover();

        _this5.$vux.toast.show({
          text: '举报已收到我们将尽快核实',
          type: 'text',
          width: '5rem',
          position: 'bottom'
        });
      });
    },

    /*
     * 赞
     * */
    like: function like(item) {
      var _this6 = this;

      if (item.isLike == '1') {
        this.$vux.toast.show({
          text: '您已赞过',
          type: 'text',
          width: '5rem',
          position: 'bottom'
        });
      } else {
        comment.like({
          commentId: item.id
        }).then(function (res) {
          _this6.$set(item, 'isLike', '1');

          _this6.$set(item, 'likeCount', item.likeCount += 1);
        });
      }
    },

    /*
     * 收藏   @this.type 评论类型  2:病例 3:资讯 ,5:直播 ,6:录播,7:点赞 8:用户帖子
     * */
    collection: function collection() {
      var _this7 = this;

      var typeFunc = function typeFunc(propType) {
        var x = 1;

        switch (propType) {
          case 2:
            x = 2;
            break;

          case 3:
            x = 1;
            break;

          case 5:
            x = 4;
            break;

          case 6:
            x = 4;
            break;

          case 8:
            x = 3;
            break;

          default:
            x = 1;
        }

        return x;
      };

      var sendData = {
        id: this.$route.params.id,
        userId: this.wxUserInfo.id,
        type: typeFunc(this.type),
        // 1资讯 2病例 3帖子 4课程
        operation: this.isCollection ? 2 : 1 //1收藏 2取消

      };
      comment.collection(sendData).then(function (res) {
        _this7.$vux.toast.show({
          text: '操作成功',
          type: 'text',
          width: '5rem',
          position: 'bottom'
        });

        _this7.$emit('event-collection', _this7.isCollection ? 0 : 1);
      }); // 埋点

      this.$sa.re_interaction({
        type: '收藏',
        // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: this.type,
        // 互动主体 直播，录播，资讯，病例，站内信，论坛
        contentid: this.$route.params.id,
        // 内容id
        first_cate: this.categoriesList[0].categoryName,
        //一级分类
        second_cate: this.categoriesList[1].categoryName,
        // 2级分类
        first_cate_id: this.categoriesList[0].id,
        // 1级分类id
        second_cate_id: this.categoriesList[1].id,
        //2级分类id
        author: this.editor,
        //讲师/作者
        contentname: this.name // location:'', //位置 站内，专区内，超级面对面内

      });
    },
    getList: function getList(params) {
      var _this8 = this; //拉取评论


      if (this.loadFlag) {
        this.loadFlag = false;
        comment.getComments(params).then(function (res) {
          var resData = res.data.data;
          _this8.commentObj.commentCount = resData.total;

          var _iterator2 = _createForOfIteratorHelper(resData.list),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              item.commentRendType = 1;

              _this8.commentContentList.push(item);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (resData.list.length < _this8.params.pageSize) {
            _this8.loadFlag = false;
            return false;
          } else {
            _this8.params.pageNo += 1;
            _this8.loadFlag = true;
          }

          console.log(_this8.commentContentList);
        });
      }
    },
    getPre: function getPre() {
      this.getList(this.params);
    },
    audioPlay: function audioPlay(e) {
      document.querySelectorAll('.voice-animate').forEach(function (item, index) {
        item.className = item.className.replace('playing', ' ');
      });
      document.querySelectorAll('audio').forEach(function (item, index) {
        item.pause();
      });

      if (e.target.className == 'audioDiv') {
        e.target.children[0].className = e.target.children[0].className + ' playing';
        e.target.children[2].play();
      } else if (e.target.parentNode.className == 'audioDiv') {
        e.target.parentNode.children[2].play();
        e.target.children[0].className = e.target.children[0].className + ' playing';
      }
    }
  },
  computed: _objectSpread({}, mapState({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    },
    categoriesList: function categoriesList(state) {
      return state.categoriesList;
    }
  })),
  watch: {
    qaId: {
      immediate: true,
      handler: function handler(n, o) {
        //评论id
        if (n != o) {
          this.commentObj = {
            commentCount: 0,
            list: []
          };
          this.commentContentList = [];
          this.loadFlag = true;
          this.params = {
            pageNo: 1,
            pageSize: 20,
            questionId: n,
            type: this.type || 0
          };
          this.getPre();
        }
      }
    },
    hasSocket: function hasSocket(n, o) {
      var that = this;

      if (n) {
        window.dmsocket.onmessage = function (event) {
          var data = event.data;
          var index = data.indexOf(':');
          var prefix = data.substr(0, index);

          if (prefix && prefix == 'COMMENT') {
            //评论
            var jsonStr = JSON.parse(data.substr(index + 1));
            jsonStr.commentRendType = 1;
            that.$emit('comList', jsonStr);

            if (that.commentTimeList.length > 200) {
              that.commentTimeList.shift();
              that.commentTimeList.push(jsonStr); // if(that.commentNameIndex==0&&that.scrollFlag){
              //   that.commentContentList = that.commentTimeList
              //   let height = this.$refs.pinglunqu.offsetHeight
              //   setTimeout(()=>{
              //     that.$refs.pinglunqu.scrollTop = 100*that.commentTimeList.length
              //   },100)
              // }
            } else {
              that.commentTimeList.push(jsonStr); // if(that.commentNameIndex==0){
              //   that.commentContentList = that.commentTimeList
              //   if(that.scrollFlag){
              //     setTimeout(()=>{
              //       that.$refs.pinglunqu.scrollTop = 100*that.commentTimeList.length
              //     },100)
              //   }
              // }
            }
          } else if (prefix == 'PRIZE') {
            //礼物
            var jsonStr = JSON.parse(data.substr(index + 1));
            jsonStr.commentRendType = 2;

            if (that.commentTimeList.length > 200) {
              that.commentTimeList.shift();
              that.commentTimeList.push(jsonStr); // if(that.commentNameIndex==0&&that.scrollFlag){
              //   that.commentContentList = that.commentTimeList
              //   setTimeout(()=>{
              //     that.$refs.pinglunqu.scrollTop = 100*that.commentTimeList.length
              //   },100)
              // }
            } else {
              that.commentTimeList.push(jsonStr); // if(that.commentNameIndex==0){
              //   that.commentContentList = that.commentTimeList
              //   if(that.scrollFlag){
              //     setTimeout(()=>{
              //       that.$refs.pinglunqu.scrollTop = 100*that.commentTimeList.length
              //     },100)
              //   }
              // }
            }

            that.$emit('transGiftList', jsonStr);
            this.newGift = jsonStr;
          } else if (prefix == 'ControlVote') {
            var jsonStr = data.substr(index + 1);

            if (/true/.test(jsonStr)) {
              that.examIndex += 1;
            } else {
              that.examIndex = 0;
            }

            that.$emit('qqquestion', that.examIndex);
          }
        };
      }
    },
    replyValue: function replyValue(n, o) {
      //监听发送栏状态
      if (n != '') {
        this.sendFlag = true;
      } else {
        this.sendFlag = false;
      }
    },
    status: function status(n, o) {
      var allHeight = document.documentElement.clientHeight / (document.body.clientWidth / 10);
      var phoneInfo = navigator.userAgent;
      var dpr = window.devicePixelRatio; // if (n == 'before') {
      //   if (/HUAWEI/.test(phoneInfo)) {
      //     this.$refs.pinglunqu.style.height = allHeight - 10.6 + 'rem';
      //   } else if (/MIX/.test(phoneInfo)) {
      //     this.$refs.pinglunqu.style.height = allHeight - 10.3 + 'rem';
      //   } else if (/iPhone/.test(phoneInfo)) {
      //     this.$refs.pinglunqu.style.height = allHeight - 10 + 'rem';
      //   } else {
      //     this.$refs.pinglunqu.style.height = allHeight - 9.6 + 'rem';
      //   }
      // } else {
      //   if (/HUAWEI/.test(phoneInfo)) {
      //     if (/AL00/.test(phoneInfo)) {
      //       //mate 10
      //       this.$refs.pinglunqu.style.height = allHeight - 7.8 + 'rem';
      //     } else {
      //       this.$refs.pinglunqu.style.height = allHeight - 9.5 + 'rem';
      //     }
      //   } else if (/MIX/.test(phoneInfo)) {
      //     this.$refs.pinglunqu.style.height = allHeight - 9.3 + 'rem';
      //   } else if (/iPhone/.test(phoneInfo)) {
      //     this.$refs.pinglunqu.style.height = allHeight - 8.8 + 'rem';
      //   } else {
      //     this.$refs.pinglunqu.style.height = allHeight - 8.7 + 'rem';
      //   }
      // }
    }
  },
  components: {
    Emoji: Emoji,
    XInput: XInput,
    flower: flower
  },
  mounted: function mounted() {},
  created: function created() {
    this.ifQua = this.wxUserInfo.userDataStatus >= 3 ? true : false;
  },
  beforeDestroy: function beforeDestroy() {}
};